import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../styles/navbar.css";
import logo from "../assets/images/logo.png";

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);

  return (
    <nav className="navbar navbar-expand-lg navbar-dark fixed-top custom-nav">
      <div className="container-fluid px-lg-5">
        <Link className="navbar-brand" to="/" onClick={closeMenu}>
          <img src={logo} className="nav-logo" alt="Aditya Exports" />
        </Link>

        <button 
          className="navbar-toggler shadow-none border-0" 
          type="button"
          onClick={toggleMenu}
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className={`collapse navbar-collapse ${isMenuOpen ? "show" : ""}`} id="adityaNavbar">
          <ul className="navbar-nav ms-auto align-items-center">

            <li className="nav-item">
              <Link className="nav-link" to="/" onClick={closeMenu}>Home</Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/about" onClick={closeMenu}>About Us</Link>
            </li>

            <li className="nav-item dropdown custom-dropdown">
              <span 
                className="nav-link dropdown-toggle" 
                role="button" 
                data-bs-toggle="dropdown"
              >
                Our Coffee
              </span>

              <ul className="dropdown-menu">
                <li>
                  <Link className="dropdown-item" to="/coffee/green" onClick={closeMenu}>
                    GREEN COFFEE BEANS
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/coffee/roasted" onClick={closeMenu}>
                    ROASTED COFFEE BEANS
                  </Link>
                </li>
              </ul>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/certificates" onClick={closeMenu}>Certificates</Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/contact" onClick={closeMenu}>Contact</Link>
            </li>

            <li className="nav-item">
              <Link to="/contact#contact-form" className="btn export-btn ms-lg-4" onClick={closeMenu}>
                Get Export Quote
              </Link>
            </li>

          </ul>
        </div>
      </div>
    </nav>
  );
}
